module.exports = __webpack_public_path__ + "static/img/main_entid.96696179.png";